// extracted by mini-css-extract-plugin
module.exports = {"buttons":"VehicleMoreInformation_buttons__3KSgF","required":"VehicleMoreInformation_required__3bhEr"};